<script setup lang="ts">
import {h, onMounted, ref, Transition} from "vue";
import CustomHeader from "@/components/CustomHeader.vue";
import Icon from "@/components/Icon.vue";
import {MenuOption, NAvatar, NMenu} from "naive-ui";
import {RouterLink} from "vue-router";
import {useEntidadeStore} from "@/stores/entidade";
import {useUserStore} from "@/stores/user";
import {capitalize} from "@/utils/utilMethods";
import KeyCloakService from "@/security/KeycloakService";
import {useRemessasStore} from "@/stores/remessa"


const entidadeStore = useEntidadeStore();
const remessaStore = useRemessasStore();
const userStore = useUserStore();
const username = ref<string>('');
const loading = ref(true);
const collapsed = ref(true);
const showName = ref(false);
const anoAtual = ref(new Date().getFullYear());

const sair = () => {
  userStore.deleteUser();
  entidadeStore.deleteEntidadeSelecionada();
  remessaStore.deleteRemessas();
  remessaStore.deleteRemessaSelecionada();
  KeyCloakService.CallLogOut()
}

onMounted(() => {
  console.log("mounted");
  setTimeout(() => {
    username.value = userStore.getUser()?.given_name!;
    loading.value = false;
  }, 100);
});

const menuOptions: MenuOption[] = [
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/home",
        },
        "Início"
      ),
    key: "inicio",
    icon: () => h(Icon, { nameIcon: "home-outline" }),
  },
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/remessas",
        },
        "Remessas"
      ),
    key: "remessas",
    icon: () => h(Icon, { nameIcon: "file-outline" }),
  },
  {
    label: () =>
      h(
        RouterLink,
        {
          to: "/",
        },
        "Entidades"
      ),
    key: "entidades",
    icon: () => h(h(Icon, { nameIcon: "restore" })),
  },
  {
    label: "Sair",
    key: "sair",
    icon: () => h(Icon, { nameIcon: "logout-variant" }),
  },
];
</script>

<template>
  <div>
    <n-layout has-sider position="absolute">
      <n-layout-sider
            collapse-mode="width"
            :collapsed-width="64"
            :width="240"
            :collapsed="collapsed"
            :onmouseover="
            () => {
                collapsed = false;
                showName = true;
            }
            "
            :onmouseout="
            () => {
                collapsed = true;
                showName = false;
            }
            "
        >
            <n-skeleton v-if="loading" text :repeat="2" />
            <div class="user__info" v-else>
            <n-avatar round :size="40" color="rgba(0, 114, 119, 1)">{{username.substring(0, 1)}}</n-avatar>
            <Transition>
                <span v-if="showName"  class="full__name">{{capitalize(username)}}</span>
            </Transition>
            </div>
            <n-menu
            class="menu"
            :collapsed="collapsed"
            :collapsed-width="64"
            :collapsed-icon-size="22"
            :options="
                menuOptions.map((option) => {
                    if (option.key === 'sair') {
                    option.onClick = () => sair();
                    }
                    return option;
                })
            "
            />
        </n-layout-sider>
        <n-layout >

        <n-layout :native-scrollbar="false" content>
            <CustomHeader />
            <slot></slot>
            </n-layout>
        </n-layout>
        <n-layout-footer position="absolute" class="copyright center">
            ©Tribunal de Contas do Estado do Maranhão - {{ anoAtual }}
        </n-layout-footer>
    </n-layout>
  </div>
</template>

<style scoped>
.user__info {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 5rem;
  background: #e7e7e7;
  padding: 8px;
}
  
.full__name {
  /* display: none; */
  margin-left: 8px;
}

.menu {
  font-weight: 500;
}

.max__size__window {
  width: 100vw;
  height: 100vh;
}

.copyright {
  font-size: 0.8rem;
}

</style>